
  import {Component, Vue} from "vue-property-decorator";
  import {IAppState} from "@/interfaces/app-state.interface";
  import {IAuth} from "@/modules/Auth/interfaces/auth.interface";
  import {IApp} from "@/interfaces/app.interface";

  @Component({})
  export default class ProfileBlock extends Vue {

    get storeState(): IAppState { return this.$store.state; }
    get userAccess(): IAuth.UserAccess { return this.storeState.auth.userAccess; }

    get userName() {
      let result = '';
      if (this.userAccess.persName) {
        result = this.userAccess.persName.replace(' ', '<br>');
      }
      return result;
    }

    async openProfile() {
      await this.$store.dispatch('openPage', { routeName: IApp.ROUTE_NAME.PAGE_PROFILE });
    }
  }
